module.exports = __webpack_public_path__ + "static/img/7.82b8be9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/7.png
// module id = 2v8k
// module chunks = 0